import React from 'react';
import IncomingRequests from './IncomingRequests/Index';
import { IApplicationHistoryEntry } from 'core/interface/applicationHistory';
import { IIndustry } from 'core/interface/companies';

interface RecruiterIncomingRequestsProps {
  id: number;
  name: string;
  sub_title: string;
  email?: string;
  icon?: string;
  score?: number;
  culture_score?: number;
  date: string;
  history?: IApplicationHistoryEntry[];
  industry?: IIndustry[];
  stage?: number;
  status: number;
  jobId?: number;
  candidateId?: number;
  handleOpenModal: (id: number, type: string) => void;
  handleCancel: (id: number) => void;
  handleAccept: (id: number) => void;
  handleDecline: (id: number) => void;
  jobTitle?: string;
  selectedBy?: { name: string } | null;
  isSelectedCandidate?: boolean;
  onStageChange?: (id: number, data: { stage: number }) => void;
  onDelete?: (id: number) => void;
  showDelete?: boolean;
}

const RecruiterIncomingRequests: React.FC<RecruiterIncomingRequestsProps> = (
  props
) => {
  const {
    handleOpenModal,
    handleAccept,
    handleDecline,
    handleCancel,
    onDelete,
    ...rest
  } = props;
  return (
    <IncomingRequests
      {...rest}
      isCandidate={false}
      setOpen={handleOpenModal}
      acceptRequest={handleAccept}
      declineRequest={handleDecline}
      cancel={handleCancel}
      onDelete={onDelete || handleCancel}
    />
  );
};

export default RecruiterIncomingRequests;
